import { ErrorComponentProps, useNavigate } from '@tanstack/react-router';
import { Dispatch, ReactElement, SetStateAction } from 'react';
import LockUp from '../assets/brand/lock-up.svg';
import { Button } from '@sc/shared-ui';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

export const Error = ({
  error,
  setResetKey,
}: ErrorComponentProps & {
  setResetKey: Dispatch<SetStateAction<string>>;
}): ReactElement => {
  const navigate = useNavigate();

  return (
    <div className="bg-background-secondary">
      <div className="h-full px-15 p-8 flex items-center flex-col">
        <LockUp className="w-40" />
        <div className="grow flex flex-col justify-center w-88">
          <div className="space-y-5 text-center flex flex-col">
            <div className="rounded-full mx-auto border border-error-400 w-fit p-6">
              <ExclamationTriangleIcon className="size-11 stroke-error-400" />
            </div>
            <h1 className="font-grotesque text-h1 font-bold text-center">
              Something went wrong
            </h1>
            <p className="text-body-medium text-text-low-priority">
              {error.message}
            </p>
            <div className="mt-5 space-y-3">
              <Button
                button={{
                  type: 'primary',
                  text: 'Retry',
                  size: 'large',
                  onClick: () => setResetKey(String(Math.random())),
                }}
              />
              <Button
                button={{
                  type: 'basic',
                  text: 'Go to dashboard',
                  size: 'large',
                  onClick: () => {
                    setResetKey(String(Math.random()));

                    void navigate({
                      to: '/',
                    });
                  },
                }}
              />
            </div>
          </div>
        </div>
        <div className="space-y-2 w-full max-w-88">
          <p>
            If you are experiencing any technical issues, please contact{' '}
            <a
              className="underline text-primary-400"
              href="mailto:support@starkchat.com"
            >
              Tech support
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};
